import { render } from "./CustomImage.vue?vue&type=template&id=99a99f62"
import script from "./CustomImage.vue?vue&type=script&lang=ts"
export * from "./CustomImage.vue?vue&type=script&lang=ts"
script.render = render

export default script